import { Typography } from "antd";
import { FC, PropsWithChildren, useEffect, useRef } from "react";

import GoapiceLogo from "@assets/img/goapice-logo.svg";
import useIsMobile from "@hooks/useIsMobile";

import styles from "./styles.module.less";

const { Title, Text } = Typography;

const MobileNotSupported: FC<PropsWithChildren> = ({ children }) => {
  const isMobile = useIsMobile();
  const appRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const appNode = appRef.current;

    if (!appNode) return;

    appNode.inert = isMobile;
  }, [isMobile]);

  return (
    <>
      <div ref={appRef} className={styles.app} aria-hidden={isMobile || undefined}>
        {children}
      </div>

      {isMobile && (
        <div className={styles.container} role="alert">
          <div className={styles.content}>
            <div className={styles.iconContainer}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ff4d4f"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
                <line x1="12" y1="18" x2="12.01" y2="18" />
                <line x1="2" y1="2" x2="22" y2="22" />
              </svg>
            </div>
            <Title level={4} className={styles.title}>
              Acesso indisponível por dispositivos móveis
            </Title>
            <Text className={styles.description}>
              Para uma melhor experiência, acesse o link através de um computador.
            </Text>
          </div>

          <div className={styles.footer}>
            <GoapiceLogo />
            <Text className={styles.copyright}>© {new Date().getFullYear()} Goapice. Todos os direitos reservados.</Text>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileNotSupported;
